import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserPermissionTreeService } from '../../features/access-control/services/user-permission-tree.service';
import { UserStore } from '../store/user.store';
import { resolveDefaultLandingPath } from './default-landing-redirect';

/** Allows login only when there is no active session; otherwise redirects to the user's default landing page. */
export const guestGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  if (!userStore.isAuthenticated()) return true;

  const permissionTree = inject(UserPermissionTreeService);
  return inject(Router).createUrlTree([resolveDefaultLandingPath(permissionTree.tree())]);
};
